import { render, staticRenderFns } from "./warehouseList.vue?vue&type=template&id=88a3fed6&scoped=true&"
import script from "./warehouseList.vue?vue&type=script&lang=js&"
export * from "./warehouseList.vue?vue&type=script&lang=js&"
import style0 from "./warehouseList.vue?vue&type=style&index=0&id=88a3fed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a3fed6",
  null
  
)

export default component.exports